import React from 'react'
import styles from './Video.module.css'

export default function Video() {
    return (
    <div className={styles.container}>
        <div className={styles.layout}>
            <div className={styles.wrapper}> 
                
            <iframe src="https://www.youtube.com/embed/8JlSQvR53MI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

            <iframe src="https://www.youtube.com/embed/SWUAqbBuHRY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

            </div>
        </div>
    </div>
    )
}
